import { MapList, NODES_PER_MAP } from '../Config/Levels';
import { IStatePlayer } from '../State/reducers/player';

export class StateUtils {
    public static newMapUnlocked(playerState: IStatePlayer) {
        const allowed = playerState.unlocked.filter(m => MapList.includes(m));
        const lasMapUnlocked = allowed.length === 0 ? null : allowed[allowed.length - 1];
        return (
            lasMapUnlocked !== MapList[0] &&
            (lasMapUnlocked !== null && !playerState.visited.includes(lasMapUnlocked))
        );
    }

    public static getNextLevelIdForMap(playerState: IStatePlayer): string {
        const { mapLevels, mapId } = playerState;
        const filtered = Object.keys(mapLevels).filter(key => key.includes(mapId));
        filtered.sort(
            (a, b) =>
                parseInt(b.substr(b.indexOf('-')), 10) - parseInt(a.substr(a.indexOf('-')), 10)
        );

        if (filtered.length === 0) {
            return mapId + '-1';
        }
        const last = filtered.pop();
        let lastIndex = parseInt(last.substr(last.indexOf('-') + 1), 10);
        if (lastIndex > NODES_PER_MAP - 1) {
            lastIndex = NODES_PER_MAP - 1;
        }
        return !mapLevels[last] || mapLevels[last].stars === 0
            ? last
            : mapId + '-' + (lastIndex + 1).toString();
    }

    public static getStarsForLevel(player: IStatePlayer, level: number) {
        const curLevelId = player.mapId + '-' + level.toString();
        if (player.mapLevels[curLevelId]) {
            return player.mapLevels[curLevelId].stars;
        }
        return 0;
    }
}
